import Validator from 'validatorjs';
import React, { Component } from 'react';
import { Button, Col, Row } from 'react-bootstrap';

import Loading from '../../../../facturotopia/loading/Loading';
import CartaPorteBaseForm from './cartaporte/CartaPorteBaseForm';
import CartaPorteMercanciasManager from './cartaporte/CartaPorteMercanciasManager';
import CartaPorteTiposFiguraManager from './cartaporte/CartaPorteTiposFiguraManager';
import CartaPorteUbicacionesManager from './cartaporte/CartaPorteUbicacionesManager';
import CartaPorteAutotransporteForm from './cartaporte/CartaPorteAutotransporteForm';
import CartaPorteClienteManager from '../../../catalogs/managers/CartaPorteClienteManager';
import CartaPorteCatalogoManager from '../../../catalogs/managers/CartaPorteCatalogoManager';
import CartaPorteRegimenesAduanerosManager from './cartaporte/CartaPorteRegimenesAduanerosManager';

class ComplementoCartaPorte extends Component {
  state = {
    data: {},
    isValid: false,
    bootCatalog: false,
    bootCatalogClient: false,
  };

  constructor(props) {
    super(props);

    let isCompleted = !!props.data?.Ubicaciones ? true : false;

    const steps = {
      base: isCompleted,
      ubicaciones: isCompleted,
      mercancias: isCompleted,
      autotransporte: isCompleted,
      tiposFigura: isCompleted,
    };

    this.state = {
      ...this.state,
      data: {
        Version: '3.1',
        ...props.data,
      },
      validator: new Validator({}, this.getRules()),
      isValid: isCompleted,
      steps: {
        ...steps,
      },
    };
  }

  componentDidMount() {
    this.loadCatalogCartaPorte();
    this.loadCatalogClienteCartaPorte();
  }

  async loadCatalogCartaPorte() {
    try {
      await CartaPorteCatalogoManager.boot();

      this.setState({
        bootCatalog: true,
      });
    } catch (error) {
      this.renderError(error);
    }
  }

  async loadCatalogClienteCartaPorte() {
    try {
      await CartaPorteClienteManager.boot();

      this.setState({
        bootCatalogClient: true,
      });
    } catch (error) {
      this.renderError(error);
    }
  }

  renderError = (error) => {
    window.ToastManager.show({
      variant: 'error',
      message: error.message || 'Error recuperando catálogo cliente carta porte',
    });
  };

  getRules = (data) => {
    return {
      TranspInternac: ['required', 'string'],
      TotalDistRec: ['required', 'numeric'],
      'Ubicaciones.Ubicacion': ['required', 'array', 'min:2'],
      'Mercancias.PesoBrutoTotal': ['required', 'min:0.001'],
      'Mercancias.UnidadPeso': ['required', 'string'],
      'Mercancias.NumTotalMercancias': ['required', 'integer'],
      'Mercancias.Mercancia': ['required', 'array', 'min:1'],
      'Mercancias.Autotransporte': ['required'],
      'FiguraTransporte.TiposFigura': ['required', 'array', 'min:1'],
    };
  };

  validate = (data) => {
    const validator = new Validator(data, this.getRules(data));

    validator.check();

    this.setState({
      validator,
    });

    return validator;
  };

  isTranspInternac = () => {
    const { TranspInternac = 'No' } = this.state.data;

    return TranspInternac !== 'No';
  };

  handleOnChange = (value, event = null) => {
    const data = {
      ...this.state.data,
      ...value,
    };

    const validator = this.validate(data);

    let { steps } = this.state;

    if (event) {
      steps = {
        ...steps,
        [event.name]: event.isValid,
      };
    }

    this.setState({
      data,
      isValid: validator.passes() && event.isValid,
      steps: steps,
    });
  };

  handleOnAdd = () => {
    const { data = {} } = this.state;

    this.props.onChange({ CartaPorte: data });

    this.clearState();
  };

  handleOnCancel = () => {
    this.props.onCancel('CartaPorte');
  };

  clearState = () => {
    this.setState({});
  };

  render() {
    const { isValid, data = {}, steps, bootCatalog } = this.state;

    if (!bootCatalog) {
      return <Loading />;
    }

    return (
      <>
        <div className="pb-4 text-right">
          <strong className="text-black text-upper">Complemento Carta Porte</strong>
        </div>

        <CartaPorteBaseForm
          data={data}
          onFormDataChange={this.handleOnChange}
        />

        {steps.base && this.isTranspInternac() && (
          <CartaPorteRegimenesAduanerosManager
            data={data}
            onChange={this.handleOnChange}
          />
        )}

        {steps.base && (
          <CartaPorteUbicacionesManager
            data={data}
            onChange={this.handleOnChange}
          />
        )}

        {steps.ubicaciones && (
          <CartaPorteMercanciasManager
            data={data}
            onChange={this.handleOnChange}
          />
        )}

        {steps.mercancias && (
          <CartaPorteAutotransporteForm
            data={data}
            onAdd={this.handleOnChange}
          />
        )}

        {steps.autotransporte && (
          <CartaPorteTiposFiguraManager
            data={data}
            onChange={this.handleOnChange}
          />
        )}

        <Row className="pb-3 text-right">
          <Col>
            <Button
              variant="secondary"
              className="mr-3"
              onClick={this.handleOnCancel}
            >
              Cancelar
            </Button>

            <Button
              variant="primary"
              disabled={!isValid}
              onClick={this.handleOnAdd}
            >
              Agregar complemento
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}

export default ComplementoCartaPorte;
